if (!window.fetch) window.fetch = require('unfetch').default || require('unfetch');



//////////////////
// WEBPACK FOOTER
// ./~/unfetch/polyfill.js
// module id = 105
// module chunks = vendor